module.exports = __webpack_public_path__ + "static/media/projects.8f712192.png";